<template>
  <transition name="modal-fade">
    <div v-if="visible" class="modal-mask" @click.self="handleClose">
      <div class="modal-panel" role="dialog" aria-modal="true">
        <button type="button" class="close-btn" aria-label="关闭" @click="handleClose">
          <i class="bi bi-x-lg"></i>
        </button>

        <div class="modal-header-bg"></div>
        <div class="modal-title-row">
          <h2><span class="title-fire" aria-hidden="true">🔥</span> {{ promo.label }}</h2>
          <p class="subtitle">{{ promo.subtitle }}</p>
        </div>

        <div class="modal-body">
          <div class="qr-wrap">
            <img :src="promo.qrImageUrl" alt="企业微信号二维码" class="qr-img" />
          </div>

          <ol class="steps">
            <li v-for="(step, idx) in promo.steps" :key="idx">{{ step }}</li>
          </ol>

          <div class="invite-row">
            <span class="invite-label">分享文案</span>
            <div class="share-box">
              <textarea
                class="share-textarea"
                :value="shareText || (loadingInvite ? '加载中…' : '')"
                rows="3"
                readonly />
              <button
                type="button"
                class="copy-btn"
                :disabled="!shareText || copying"
                @click="copyShareText">
                {{ copyLabel }}
              </button>
            </div>
          </div>
          <p v-if="loadError" class="error-msg">{{ loadError }}</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { getInviteInfo } from '@/api/portal/invite'
import { WECHAT_CONTACT_PROMO } from '@/constants/marketingWechatContact'
import { copyText } from '@/utils/invite'

export default {
  name: 'WechatContactPromoModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      promo: WECHAT_CONTACT_PROMO,
      shareText: '',
      loadingInvite: false,
      loadError: '',
      copying: false,
      copyLabel: '复制'
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.loadShareText()
      }
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    loadShareText() {
      this.shareText = ''
      this.loadError = ''
      this.loadingInvite = true
      getInviteInfo()
        .then(res => {
          this.shareText = ((res.data || {}).shareText || '').trim()
          if (!this.shareText) {
            this.loadError = '暂未获取到分享文案，请稍后重试'
          }
        })
        .catch(() => {
          this.loadError = '分享文案加载失败，请确认已登录'
        })
        .finally(() => {
          this.loadingInvite = false
        })
    },
    copyShareText() {
      if (!this.shareText) {
        return
      }
      this.copying = true
      copyText(this.shareText)
        .then(ok => {
          this.copyLabel = ok ? '已复制' : '复制失败'
        })
        .finally(() => {
          this.copying = false
          setTimeout(() => {
            this.copyLabel = '复制'
          }, 2000)
        })
    }
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.modal-panel {
  position: relative;
  width: 100%;
  max-width: 440px;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.18);
}

.close-btn {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 2;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.85);
}

.modal-header-bg {
  height: 72px;
  background: linear-gradient(135deg, #1976d2 0%, #42a5f5 100%);
}

.modal-title-row {
  margin-top: -40px;
  padding: 0 24px 8px;
  position: relative;
  z-index: 1;
}

.modal-title-row h2 {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  display: flex;
  align-items: center;
  gap: 6px;
  line-height: 1.35;
}

.title-fire {
  font-size: 22px;
  line-height: 1;
  flex-shrink: 0;
}

.subtitle {
  margin-top: 8px;
  font-size: 13px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.92);
}

.modal-body {
  padding: 16px 24px 24px;
}

.qr-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.qr-img {
  width: 220px;
  height: 220px;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid #eef0f4;
  background: #f9fafb;
}

.steps {
  margin: 0 0 16px;
  padding-left: 20px;
  font-size: 13px;
  line-height: 1.6;
  color: #4b5563;
}

.invite-row {
  background: #f9fafb;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid #eef0f4;
}

.invite-label {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 8px;
}

.share-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.share-textarea {
  flex: 1;
  min-height: 72px;
  padding: 8px 10px;
  font-size: 13px;
  line-height: 1.5;
  color: #374151;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  resize: none;
}

.copy-btn {
  flex-shrink: 0;
  height: 34px;
  padding: 0 14px;
  border-radius: 8px;
  background: var(--primary, #1976d2);
  color: #fff;
  font-size: 13px;
}

.copy-btn:disabled {
  opacity: 0.5;
}

.error-msg {
  margin-top: 10px;
  font-size: 12px;
  color: #ef4444;
}

.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease;
}

.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
</style>
